import { datadogLogs } from '@datadog/browser-logs';

import { initI18n, setTranslationErrorLogger } from '@shared/i18n';

import en from '../../shared/src/locales/en.json';

const languageImports = import.meta.glob<Record<string, unknown>>(
  // Skip en.json which is always included (used as the default and fallback language)
  ['../../shared/src/locales/*.json', '!../../shared/src/locales/en.json'],
  {
    import: 'default',
  }
);

const loadLanguage = async (language: string) => {
  const languageImport = languageImports[`../../shared/src/locales/${language}.json`];

  if (!languageImport) {
    return undefined;
  }

  return languageImport();
};

// Configure Datadog logging for production
if (import.meta.env.MODE === 'production') {
  setTranslationErrorLogger({
    logError: context => {
      datadogLogs.logger.error('Translation error', context);
    },
  });
}

export const initI18next = (sdkLanguage?: string) => {
  return initI18n({
    resources: { en: { translation: en } },
    defaultLanguage: sdkLanguage,
    loadLanguage,
  });
};
